import React, { useEffect, useState } from 'react';
import './HomePage.css';
import logo from './logo.png';

const ROLE_LABELS = {
  student: 'Öğrenci Paneli',
  instructor: 'Akademisyen Paneli',
  admin: 'Yönetici Paneli',
  program_baskan: 'Program Başkanı Paneli',
  rektor: 'Rektörlük Paneli',
  rektor_yardimcisi: 'Rektör Yardımcılığı Paneli',
};

const ICONS = {
  courses: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  exams: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="9" y1="13" x2="15" y2="13" />
      <line x1="9" y1="17" x2="15" y2="17" />
    </svg>
  ),
  results: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  students: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  statistics: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  'universite-raporu': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  'akademisyen-raporu': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  ),
  'sinav-raporu': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" />
      <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  ),
  'akademisyen-sinav-raporu': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3v18h18" />
      <path d="M7 14l4-4 4 4 5-5" />
    </svg>
  ),
  'calisma-konulari': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </svg>
  ),
  odevler: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="12" y1="18" x2="12" y2="12" />
      <line x1="9" y1="15" x2="15" y2="15" />
    </svg>
  ),
  sorular: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  'akademisyen-siralama': (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 6l4-4 4 4" />
      <path d="M12 2v10.3" />
      <path d="M20 21H4" />
      <path d="M6 16l2-2 2 2 4-4 4 4" />
    </svg>
  ),
};

function HomePage({ userType, onPageChange }) {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);

  const quickAccessMap = {
    student: [
      { id: 'courses', title: 'Derslerim', description: 'Kayıtlı derslerinizi görüntüleyin' },
      { id: 'calisma-konulari', title: 'Çalışma Konuları', description: 'Ders çalışma konularını ve notları inceleyin' },
      { id: 'odevler', title: 'Ödevler', description: 'Ödevlerinizi görüntüleyin ve teslim edin' },
      { id: 'exams', title: 'Sınavlarım', description: 'Aktif ve yaklaşan sınavlarınıza gidin' },
      { id: 'results', title: 'Sonuçlarım', description: 'Sınav sonuçlarınızı inceleyin' },
    ],
    instructor: [
      { id: 'students', title: 'Öğrenciler', description: 'Öğrenci listelerini görüntüleyin' },
      { id: 'courses', title: 'Derslerim', description: 'Sorumlu olduğunuz dersleri görüntüleyin' },
      { id: 'calisma-konulari', title: 'Çalışma Konuları', description: 'Ders çalışma konularını yönetin' },
      { id: 'odevler', title: 'Ödevler', description: 'Ödev yükleyin ve öğrenci teslimlerini inceleyin' },
      { id: 'exams', title: 'Sınav Yönetimi', description: 'Sınavlarınızı oluşturun, düzenleyin ve yayınlayın' },
      { id: 'sorular', title: 'Sorular', description: 'Soru bankasını görüntüleyin ve düzenleyin' },
      { id: 'statistics', title: 'Ders İstatistikleri', description: 'Ders ve sınav başarı analizlerini inceleyin' },
    ],
    admin: [
      { id: 'users', title: 'Akademisyenler', description: 'Akademisyen kayıtlarını yönetin' },
      { id: 'students', title: 'Öğrenciler', description: 'Öğrenci listelerini görüntüleyin' },
      { id: 'courses', title: 'Dersler', description: 'Ders ve program yapılarını görüntüleyin' },
      { id: 'universite-raporu', title: 'Üniversite Raporu', description: 'Üniversite geneli sınav raporlarını açın' },
      { id: 'akademisyen-raporu', title: 'Akademisyen Raporu', description: 'Akademisyen bazlı sınav raporlarını açın' },
    ],
    program_baskan: [
      { id: 'students', title: 'Öğrenciler', description: 'Programınızdaki öğrencileri görüntüleyin' },
      { id: 'courses', title: 'Dersler', description: 'Programınıza ait dersleri görüntüleyin' },
      { id: 'calisma-konulari', title: 'Çalışma Konuları', description: 'Ders çalışma konularını yönetin' },
      { id: 'odevler', title: 'Ödevler', description: 'Ödev yükleyin ve öğrenci teslimlerini inceleyin' },
      { id: 'sorular', title: 'Sorular', description: 'Soru bankasını görüntüleyin ve düzenleyin' },
      { id: 'exams', title: 'Sınav Yönetimi', description: 'Program kapsamındaki sınavları yönetin' },
      { id: 'sinav-raporlari', title: 'Sınav Raporları', description: 'Genel bakış, katılım ve istatistikleri inceleyin' },
      { id: 'akademisyen-siralama', title: 'Akademisyen Etkinliği', description: 'Akademisyenlerin sınav etkinliğini inceleyin' },
    ],
    rektor: [
      { id: 'students', title: 'Öğrenciler', description: 'Öğrenci listelerini görüntüleyin' },
      { id: 'courses', title: 'Dersler', description: 'Üniversite genelindeki dersleri görüntüleyin' },
      { id: 'calisma-konulari', title: 'Çalışma Konuları', description: 'Ders çalışma konularını yönetin' },
      { id: 'odevler', title: 'Ödevler', description: 'Ödev yükleyin ve öğrenci teslimlerini inceleyin' },
      { id: 'sorular', title: 'Sorular', description: 'Soru bankasını görüntüleyin ve düzenleyin' },
      { id: 'sinav-raporu', title: 'Üniversite Sınav Raporları', description: 'Üniversite genelindeki sınav raporlarını açın' },
      { id: 'akademisyen-sinav-raporu', title: 'Akademisyen Etkinliği', description: 'Akademisyen bazlı sınav etkinliğini inceleyin' },
      { id: 'statistics', title: 'Üniversite İstatistikleri', description: 'Üniversite genelindeki başarı istatistiklerini inceleyin' },
    ],
    rektor_yardimcisi: [
      { id: 'students', title: 'Öğrenciler', description: 'Öğrenci listelerini görüntüleyin' },
      { id: 'courses', title: 'Dersler', description: 'Üniversite genelindeki dersleri görüntüleyin' },
      { id: 'calisma-konulari', title: 'Çalışma Konuları', description: 'Ders çalışma konularını yönetin' },
      { id: 'odevler', title: 'Ödevler', description: 'Ödev yükleyin ve öğrenci teslimlerini inceleyin' },
      { id: 'sorular', title: 'Sorular', description: 'Soru bankasını görüntüleyin ve düzenleyin' },
      { id: 'sinav-raporu', title: 'Üniversite Sınav Raporları', description: 'Üniversite genelindeki sınav raporlarını açın' },
      { id: 'akademisyen-sinav-raporu', title: 'Akademisyen Etkinliği', description: 'Akademisyen bazlı sınav etkinliğini inceleyin' },
      { id: 'statistics', title: 'Üniversite İstatistikleri', description: 'Üniversite genelindeki başarı istatistiklerini inceleyin' },
    ],
  };

  const handleCardClick = (pageId) => {
    if (onPageChange) onPageChange(pageId);
  };

  const quickAccessItems = quickAccessMap[userType] || quickAccessMap.instructor;
  const roleLabel = ROLE_LABELS[userType] || ROLE_LABELS.instructor;

  const dateLabel = now.toLocaleDateString('tr-TR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  const timeLabel = now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });

  const getGreeting = () => {
    const h = now.getHours();
    if (h < 6) return 'İyi geceler';
    if (h < 12) return 'Günaydın';
    if (h < 18) return 'İyi günler';
    return 'İyi akşamlar';
  };

  return (
    <div className="home-page">
      <section className="home-hero">
        <div className="home-hero-pattern" aria-hidden="true" />
        <div className="home-hero-inner">
          <div className="home-hero-brand">
            <div className="home-hero-logo">
              <img src={logo} alt="KOSTÜ Logo" />
            </div>
            <div className="home-hero-text">
              <span className="home-hero-eyebrow">Kocaeli Sağlık ve Teknoloji Üniversitesi</span>
              <h1 className="home-hero-title">Sınav Yönetim Sistemi</h1>
              <p className="home-hero-subtitle">
                {getGreeting()}, {roleLabel.toLowerCase()}'ne hoş geldiniz.
              </p>
            </div>
          </div>
          <div className="home-hero-meta">
            <div className="home-hero-meta-card">
              <span className="home-hero-meta-label">Bugün</span>
              <span className="home-hero-meta-value">{dateLabel}</span>
              <span className="home-hero-meta-time">{timeLabel}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="home-quick">
        <div className="home-quick-header">
          <h2>Hızlı Erişim</h2>
          <span className="home-quick-sub">{roleLabel}</span>
        </div>
        <div className="home-quick-grid">
          {quickAccessItems.map((item) => (
            <button
              key={item.id}
              type="button"
              className="quick-card"
              onClick={() => handleCardClick(item.id)}
            >
              <span className="quick-card-icon">{ICONS[item.id] || ICONS.exams}</span>
              <span className="quick-card-body">
                <span className="quick-card-title">{item.title}</span>
                <span className="quick-card-desc">{item.description}</span>
              </span>
              <span className="quick-card-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </span>
            </button>
          ))}
        </div>
      </section>

      <footer className="home-footer">
        <span>© {now.getFullYear()} Kocaeli Sağlık ve Teknoloji Üniversitesi</span>
        <span className="home-footer-sep">•</span>
        <span>Sınav Modülü</span>
      </footer>
    </div>
  );
}

export default HomePage;
